import { render, staticRenderFns } from "./CreateNewShortLinkDialog.vue?vue&type=template&id=36b06b1a"
import script from "./CreateNewShortLinkDialog.vue?vue&type=script&lang=ts"
export * from "./CreateNewShortLinkDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports